"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useActions = void 0;
const react_1 = require("react");
const useActions = (actions, state, dispatch) => {
    const getState = (0, react_1.useCallback)(() => state, [state]);
    const result = (0, react_1.useMemo)(() => {
        const wrappedActions = {};
        for (const actionName of Object.keys(actions)) {
            const action = actions[actionName];
            wrappedActions[actionName] = (...args) => {
                const performedAction = action(...args);
                if (typeof performedAction === 'function') {
                    return performedAction(getState, dispatch);
                }
                return dispatch(performedAction);
            };
        }
        return wrappedActions;
    }, [actions, dispatch, getState]);
    return result;
};
exports.useActions = useActions;
//# sourceMappingURL=index.js.map